import { JSX } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import styles from './TypeChangeDialog.module.scss'

interface IChangeDialogProps {
  onDiscard: () => void
  onApply: () => Promise<void>
  onCancel: () => void
  message?: string
  content?: JSX.Element
}

export const TypeChangeDialog = (props: IChangeDialogProps) => {
  const defaultMessage = 'You have unsaved data, would you really like to leave the tab?'

  return (
    <>
      <div className={styles.dialogContainer}>
        <p className={styles.confirmTitle}>Please confirm step</p>
        {props.content ? <p>{props.content}</p> : <p>{props.message || defaultMessage}</p>}
        <br />
        <div className={styles.buttons}>
          <Button
            className={styles.button}
            color="danger"
            onClick={() => {
              props.onDiscard()
            }}
          >
            <Translation text="jbp-discard" />
          </Button>
          <Button className={styles.button} onClick={async () => await props.onApply()}>
            <Translation text="jbp-save" />
          </Button>
          <Button className={styles.button} color="grey" onClick={() => props.onCancel()}>
            <Translation text="jbp-cancel" />
          </Button>
        </div>
      </div>
    </>
  )
}
